export const VISIBILITY_TRANSLATION_NAMESPACE = "visibility";

export const VISIBILITY_COMMON_TK = "VISIBILITY_COMMON_TK";
export const VISIBILITY_RANKING_LIST_TK = "VISIBILITY_RANKING_LIST_TK";
export const VISIBILITY_OFFER_LIST_TK = "VISIBILITY_OFFER_LIST_TK";
export const VISIBILITY_EXPORT_DIALOG_TK = "VISIBILITY_EXPORT_DIALOG_TK";
